import { Spin } from 'antd';
import React, { ReactElement } from 'react';

import classes from './Loader.module.css';

export default function Loader(): ReactElement {
  return (
    <div className={classes.progressContainer}>
      <Spin size="large" />
    </div>
  );
}
